import React from 'react';
import { Row, Col, Input } from 'antd';
import styled from 'styled-components';

const { TextArea } = Input;

const SelectRow = styled(Row)``;

const Container = styled.div`
  marging: 10px;
`;

function Description({ description, itemKey, changeItemProperty }) {
  const handleChange = (e) => {
    changeItemProperty(itemKey, 'description', e.target.value);
  };

  return (
    <Container id="container">
      <Row style={{ marginBottom: '5px' }}>
        <Col>Additional Notes:</Col>
      </Row>
      <SelectRow>
        <Col span={24}>
          <TextArea
            defaultValue={description}
            onChange={handleChange}
            autoSize={{ minRows: 1, maxRows: 10 }}
            data-testid="additional-notes-input"
          />
        </Col>
      </SelectRow>
    </Container>
  );
}

export default Description;
